import { changeModuleStatus } from '../../../../services/popupApi';

function findSelectedStatusOption(status, dynamicOptions) {
  const options = dynamicOptions?.status ?? [];
  return options.find((option) => String(option?.value ?? '') === String(status ?? '')) ?? null;
}

export const api = {
  submit: async (values, context, submitPayload) => {
    const selectedOption = findSelectedStatusOption(values.status, submitPayload?.dynamicOptions);
    const raw = selectedOption?._raw ?? {};

    const status = {
      clientSubmissionStatusText: String(values.status ?? '').trim(),
      clientSubmissionStatusId: Number(raw.id ?? raw.uniqueId ?? 0) || 0,
      clientSubmissionStatusType: String(raw.type ?? '').trim(),
    };

    await changeModuleStatus(context.moduleName, context.selectedIds, status);
  },
};
